// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2W6zm","col":"styles_col__1k-HO"};